/* eslint-disable id-blacklist */
/* eslint-disable @typescript-eslint/naming-convention */

// eslint-disable-next-line import/no-default-export
export default {
    common: {
        chooseItem: 'Kies {0}',
        description: 'Beschrijving',
        settings: 'Instellingen',
        condition: 'Conditie',
        conditions: 'Condities',
        care: 'Verzorging',
        coordinates: 'Coördinaten',
        date: 'Datum',
        startDate: 'Start datum',
        endDate: 'Eind datum',
        time: 'Tijd',
        startTime: 'Start tijd',
        endTime: 'Eind tijd',
        start: 'Start',
        end: 'Eind',
        total: 'Totaal',
        dateAdded: 'Datum toegevoegd',
        defect: 'Gebrek',
        defects: 'Gebreken',
        file: 'Bestand',
        filename: 'Bestandsnaam',
        user: 'Gebruiker',
        users: 'Gebruikers',
        emailAddress: 'E-mailadres',
        inspectionStandard: 'Inspectiestandaard',
        inspectionCompositionStandard: 'Inspectie / decompositie standaard',
        password: 'Wachtwoord',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        mobileNumber: 'Mobiel nummer',
        officeNumber: 'Kantoor nummer',
        lastLogin: 'Laatste login',
        cancel: 'Annuleer',
        save: 'Opslaan',
        close: 'Sluiten',
        companies: 'Bedrijven',
        company: 'Bedrijf',
        composition: 'Decompositie',
        addItem: '{0} toevoegen',
        editItem: '{0} bewerken',
        removeItem: '{0} verwijderen',
        findItem: '{0} zoeken',
        filterItem: '{0} filteren',
        saveItem: '{0} opslaan',
        showItem: '{0} tonen',
        importItem: '{0} importeren',
        name: 'Naam',
        search: 'Zoek',
        actions: 'Actie',
        edit: 'Bewerk',
        remove: 'Verwijder',
        enabled: 'Ingeschakeld',
        disabled: 'Uitgeschakeld',
        enable: 'Inschakelen',
        disable: 'Uitschakelen',
        administrator: 'Administrator',
        surveyor: 'Inspecteur',
        operator: 'Uitvoerder',
        client: 'Klant',
        clients: 'Klanten',
        owner: 'Eigenaar',
        owners: 'Eigenaren',
        role: 'Rol',
        previous: 'Vorige',
        next: 'Volgende',
        location: 'Locatie',
        object: 'Object',
        objects: 'Objecten',
        objectType: 'Object type',
        objectTypes: 'Type objecten',
        inspectionType: 'Inspectie type',
        inspectionTypes: 'Type inspecties',
        survey: 'Inspectie',
        selectItem: 'Selecteer {0}...',
        searchItem: 'Zoek een {0}...',
        allItems: 'Alle {0}',
        labels: 'Labels',
        label: 'Label',
        code: 'Code',
        part: 'Deel',
        element: 'Element',
        elements: 'Elementen',
        remark: 'Opmerking',
        remarks: 'Opmerkingen',
        saved: 'Gegevens zijn opgeslagen.',
        show: 'Toon',
        hide: 'Verberg',
        size: 'Grootte',
        duration: 'Duur',
        status: 'Status',
        surveys: 'Inspecties',
        type: 'Type',
        types: 'Typen',
        unit: 'Onderdeel',
        units: 'Bouwdelen',
        routeNotFound: 'Gevraagd pad niet gevonden of algemene fout',
        goToDefaultPage: 'Klik hier om naar startpagina (overzicht inspecties) te gaan.',
        select: 'Selecteer',
        deselect: 'Deselecteer',
        list: 'Lijst',
        map: 'Kaart',
        reports: 'Rapporten',
        surveyReports: 'Inspecties',
        documentation: 'Documentatie',
        system: 'Beheer',
        objectDetails: 'Object details',
        surveyDetails: 'Inspectie details',
        logout: 'Uitloggen',
        profile: 'Profiel',
        dashboard: 'Dashboard',
        title: 'Titel',
        permissionError: 'U heeft onvoldoende rechten',
        inspectionTemplate: 'Inspectiemodel',
        confirmDeleteItem: 'Weet u zeker dat u dit item wilt verwijderen?',
        confirmDelete: 'Weet u zeker dat u "{0}" wilt verwijderen?',
        confirmMultiDelete: 'Weet u zeker dat u alle items wilt verwijderen?',
        projectNumber: 'Rapportnummer',
        category: 'Categorie',
        manifestation: 'Verschijningsvorm',
        manifestations: 'Verschijningsvormen',
        files: 'Bestanden',
        cost: 'Kosten',
        year: 'Jaar',
        other: 'Anders',
        cut: 'Knippen',
        copy: 'Kopieren',
        annotations: 'Annotaties',
        isActive: 'Actief',
        language: 'Taal',
        yes: 'Ja',
        no: 'Nee',
        archive: 'Archief',
        material: 'Materiaal',
        top: 'Naar top',
        up: 'Naar boven',
        down: 'Naar beneden',
        submit: 'Versturen',
        quantity: 'Hoeveelheid',
        pcs: 'st',
        export: 'Exporteer',
        visuals: 'Afbeeldingen',
        added: 'toegevoegd',
        general: 'Algemeen',
        dimensions: 'Afmetingen',
        classification: 'Indeling',
        move: 'Verplaats',
        measurements: 'Metingen',
        priority: 'Prioriteit',
        isArchived: 'Uitgeschakeld',
        usage: 'Gebruik',
        softwareVersion: 'Softwareversie',
        period: 'Periode',
        reset: 'Wis',
        result: 'Resultaat',
        from: 'van',
        to: 'tot',
        progress: 'Voortgang',
        non: 'Geen',
        explanation: 'Toelichting',
        missingTranslationKey: 'Ontbrekende vertaalsleutel',
        province: 'Provincie',
        municipality: 'Gemeente',
        days: 'Dagen',
        history: 'Historie',
        generate: 'Genereren',
        amount: 'Aantal',
        totalAmount: 'Total aantal',
        today: 'Vandaag',
        conditionReport: 'Conditierapport',
        inspectionReport: 'Inspectierapport',
        dateInspection: 'Onderzoeksdatum',
        dateReport: 'Datum rapportage',
        inspector: 'Inspecteur',
        constructionYear: 'Bouwjaar',
        advice: 'Advies',
        seriousness: 'Ernst',
        intensity: 'Intensiteit',
        extend: 'Omvang',
        measures: 'Maatregelen',
        images: 'Beeldmateriaal',
        imagesExplanation: 'Ondersteunend beeldmateriaal bij de conditierapportage',
        noImages: "Geen foto's beschikbaar of geen foto's geselecteerd voor",
        all: 'Alles',
        excelExport: 'Excel export',
        id: 'Id',
        field: 'Veld',
        value: 'Waarde',
        selectedPoint: 'Geselecteerd punt',
        order: 'Volgorde',
        conductedPeriod: 'Uitgevoerd in periode:',
        assessment: 'Beoordeling',
        showAll: 'Toon alles',
        showLess: 'Toon minder',
        template: 'Model',
        productReports: 'Producten',
        dateRange: 'Periode:',
        product: 'Product',
        invalidId: 'ongeldig ID',
        doesNotExistAnymore: 'bestaat niet (meer)',
        noAccess: 'geen toegang',
        update: 'Wijzigen',
        bulkUpdate: 'Bulk wijzigen',
        on: 'aan',
        off: 'uit',
        searchText: 'Zoeken op tekst',
    },
    asset: {
        filterOnLabel: 'Documenten filteren op labels',
        filterOnText: 'Documenten filteren op text',
        search: 'Zoeken',
        manageLabelsModal: 'Labels voor document beheren',
        addRemoveLabels: 'Selecteer labels die u wilt toepassen op document "{0}"',
        errorStorageLimitReached: 'Opslaglimiet bereikt, kan geen bestanden meer uploaden.',
        errorFileTooBig: 'Bestand is te groot.',
        asset: 'Asset',
        iconTitleAssetsAvailable: 'Afbeeldingen beschikbaar',
        remove360: 'Geen panorama',
        set360: 'Instellen als panorama',
        processingVideo: 'Verwerken video',
        processingThumbnail: 'Miniatuur genereren',
        showGallery: 'Toon foto-galerij',
        showColumns: 'Toon kolommen',
        settings: 'Asset instellingen',
    },
    defect: {
        customDefect: 'Nieuw gebrek',
        description: 'Beschrijving gebrek',
        seriousness: 'Ernst',
        intensity: 'Intensiteit',
        extend: 'Omvang',
        defectSpec: 'Specificaties gebrek',
    },
    login: {
        enterEmailAddress: 'Geef e-mailadres',
        enterPassword: 'Geef wachtwoord',
        signIn: 'Inloggen',
        forgotPassword: 'Wachtwoord vergeten?',
        moreInformation: 'Voor meer informatie over ZXY cloud',
        clickHere: 'klik hier',
        failMessage: 'E-mailadres en wachtwoord komen niet overeen. Na te veel mislukte pogingen wordt je account tijdelijk geblokkeerd.',
        blocked: 'Uw account is geblokkeerd omdat er te veel mislukte inlogpogingen zijn',
        tempLogin: 'Login verzoek aanvragen... even geduld.',
        tempLoginFailed: 'Login mislukt, neem contact op met systeembeheerder.',
        failedSendShareLink: 'Bericht kon niet worden verzonden. Controleer het e-mailadres en probeer opnieuw.',
        useSso: 'Gebruik single sign on in te loggen.',
        enterOtpCode: 'Voer de twee factor authenticatie code in.',
        otpCode: 'Code',
        otpCodeInvalid: 'Code niet geldig.',
        invalidHost: 'Ongeldige URL, probeer:',
        selectCompany: 'Selecteer een bedrijf:',
    },
    profile: {
        changePassword: 'Verander wachtwoord',
        currentPassword: 'Huidig wachtwoord',
        newPassword: 'Nieuw wachtwoord',
        repeatNewPassword: 'Herhaal wachtwoord',
        passwordAge: 'Het huidige wachtwoord is {0} dagen oud.',
        errorPasswordsNotEqual: 'Wachtwoorden zijn niet gelijk',
        errorPasswordNotCorrect: 'Foutief wachtwoord',
        errorPasswordOldSameAsNew: 'Het nieuwe wachtwoord mag niet het zelfde zijn als het huidige wachtwoord.',
        errorPasswordTooSmall: 'Wachtwoord te kort. Minimum lengte is 8 karakters',
        errorNoPunctuation: 'Wachtwoord moet minimaal een leesteken bevatten',
        messageChanged: 'Wachtwoord is aangepast',
        twoFactorAuthentication: 'Authenticatie in twee stappen',
        twoFactorAuthenticationStepOne: 'Gebruik een Authenticator app om de QR code te scannen.',
        twoFactorAuthenticationStepTwo: ' Vul de 6 cijferige code in die getoond wordt in de Authenticator app.',
        twoFactorAuthenticationIsEnabled: 'Authenticatie in twee stappen staat AAN.',
        twoFactorAuthenticationIsDisabled: 'Authenticatie in twee stappen staat UIT.',
        twoFactorAuthenticationExplanation:
            'Met verificatie in twee stappen voegt u een extra beveiligingslaag aan uw account toe. Deze verificatie werkt met Google Authenticator, FreeOTP of een andere app die eenmalige verificatiecodes genereert.',
        twoFactorAuthenticationExplanationDisable:
            'Als u authenticatie in twee stappen uitschakelt, wordt de extra beveiligingslaag van uw account verwijderd en gebruik u alleen het wachtwoord om in te loggen.',
        otpCode: '6 cijferige code',
    },
    user: {
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        emailAddress: 'Emailadres',
        mobileNumber: 'Mobielnummer',
        officeNumber: 'Kantoor nummer',
        password: 'Wachtwoord',
        repeatPassword: 'Herhaal wachtwoord',
        language: 'Selecteer taal',
        saveUser: 'Gebruiker opslaan',
        dutch: 'Nederlands',
        english: 'Engels',
        statusLanguage: 'Status en taal',
        errorEmailAlreadyInCompany: 'Het verstrekte e-mailadres is al in gebruik binnen het bedrijf',
        errorEmailAlreadyInTenant:
            'Het verstrekte e-mailadres is al in gebruik binnen uw tenant. Voeg de bestaande gebruiker toe of neem contact op met support.',
        errorEmailNotUnique: 'Het verstrekte e-mailadres is al in gebruik. Kies een ander e-mailadres of neem contact op met support',
        errorEmailNotValid: 'Het verstrekte e-mailadres is ongeldig.',
        managerRoles: 'Systeembeheer rechten',
        isAccountManager: 'Account beheer',
        isConfigurationManager: 'Configuratie beheer',
        isDroneOperator: 'Drone-operator',
        isReadOnly: 'Enkel leesrechten',
        isReadOnlyExplanation: 'Gebruiker kan geen data toevoegen, bewerken of verwijderen.',
        passwordExplanation: 'Als wachtwoordveld leeg wordt gelaten blijft het huidige wachtwoord behouden.',
        generatePasswordLink: 'Verstuur een mail om account te activeren',
        generatePasswordLinkExplanation: 'Gebruiker krijgt een e-mail met daarin een link om account te activeren en een wachtwoord op te geven.',
        resetAccount: 'Wachtwoord herstellen',
        resetAccountExplanation: 'Gebruiker krijgt een e-mail met daarin een link om een nieuw wachtwoord op te geven.',
        pointCloudNotEnabled: 'Het gebruik van pointclouds binnen de ADW omgeving staat uit voor uw profiel.',
        otp: 'Multifactor Authenticatie',
        resetOtp: 'Reset 2FA',
        resetOtpExplanation: 'Multifactor authenticatie wordt verwijderd zodat gebruiker dit opnieuw kan instellen.',
        emailMessage: 'Optioneel extra bericht in e-mail',
        newUser: 'Nieuwe gebruiker',
        existingUser: 'Bestaande gebruiker',
        existingUsers: 'Bestaande gebruikersen',
        addExistingUserToCompany: 'Voeg bestaande gebruiker toe aan dit bedrijf',
        confirmRemoveFromCompany: 'Weet u zeker dat u "{0}" wilt verwijderen van dit bedrijf?',
        administratorAddExistingUserWarning:
            'Als beheerder kan het voorkomen dat u per ongeluk een gebruiker van de ene klant aan een andere klant toevoegt. Dit kan leiden tot ongewenste resultaten, dus wees voorzichtig.',
    },
    validation: {
        general: 'Er is iets mis gegaan, probeer het alstublieft nogmaals.',
        NOT_ALLOWED: 'Er is iets mis gegaan, neem contact op met de helpdesk.',
        PASSWORD_LINK_EXPIRED: 'De link is niet meer geldig',
        PASSWORD_TOO_SHORT: 'Wachtwoord te kort. Minimum lengte is 8 karakters',
        PASSWORD_NO_PUNCTUATION: 'Wachtwoord moet minimaal een leesteken bevatten',
        PASSWORD_NOT_THE_SAME: 'Bedide wachtwoorden zijn niet gelijk',
        EMAIL_NOT_VALID: 'Emailadres is niet geldig',
        FAILED_SENDING_MAIL: 'Mail kon niet verstuurd worden. Neem contact the service desk.',
        min: '"{0} moet groter of gelijk zijn aan "{1}"',
        greater: '"{0}" moet groter zijn dan "{1}"',
        REQUIRED: 'Verplicht',
        any_empty: 'Mag niet leeg zijn',
        any_required: 'Mag niet leeg zijn',
        date_base: 'Moet een geldige datum zijn',
        string_base: 'Mag niet leeg zijn',
        number_base: 'Moet een nummer zijn',
        number_min: 'Getal moet groter zijn',
        number_less: 'Getal moet kleiner zijn',
        number_integer: 'Moet een geheel getal zijn',
    },
    company: {
        storageUsed: 'Beschikbare opslag',
        registeredOn: 'Geregistreerd op',
        findCompany: 'Zoek bedrijf',
        companyName: 'Bedrijfsnaam',
        companyRole: 'Rol',
        companyCompanyRole: 'Bedrijfsrol',
        streetAndNumber: 'Straatnaam + nummer',
        details: 'Bedrijfsdetails',
        zipCode: 'Postcode',
        city: 'Plaats',
        state: 'Provincie',
        country: 'Land',
        statusAndStorage: 'Status en opslag',
        supportEmailAddress: 'E-mailadres ondersteuning',
        supportEmailExplanation:
            'Ondersteuningsvragen van gebruikers worden doorgestuurd naar dit e-mailadres. Wordt hier niets opgegeven dan gaan ondersteuningsvragen naar het centrale e-mailadres.',
        storageMb: 'Opslag MB',
        addRelation: 'Relatie toevoegen',
        addUser: 'Gebruiker toevoegen',
        editCompany: 'Bedrijf bewerken',
        relation: 'Relatie',
        relations: 'Bedrijfsrelaties',
        usage: 'Maandoverzicht',
        isClient: 'Bedrijf is een klant',
        isClientExplanation: 'Een klant kan objecten inspecties en bedrijven aanmaken en beheren.',
        saveCompanyAndAddUser: 'Bedrijf opslaan & gebruiker toevoegen',
        authenticationToken: 'Authenticatie token',
        useBatches: 'Maak gebruik van batch model',
        useBatchesExplanation:
            'Objecten worden in batches toebedeeld aan een inspecteur of uitvoerder die daarmee rechten krijgt tot dat object. Als de batch wordt afgesloten verlopen deze rechten. Wordt er geen gebruik gemaakt van de batche-instelling dan heeft een inspecteur of uitvoerder rechten op alle objecten.',
        useSurveyComments: 'Maak gebruik van inspectie opmerkingen',
        useSurveyCommentsExplanation: 'Specificeert of er opmerkingen kunnen worden toegevoegd aan inspecties.',
        useNen2767Advanced: 'Gebruik NEN2767 (geavanceerd)',
        useNen2767AdvancedExplanation: 'uitleg...', // TODO
        mapSettings: 'Kaartinstellingen',
        clientSettings: 'Klantinstellingen',
        isPdokMapLayerAvailable: 'Nederlandse Pdok kaartlaag beschikbaar',
        areLabelsVisibleInOverviews: 'Labels zichtbaar in overzichten',
        isDroneNoFlyMapNlAvailable: "Nederlandse drone 'no fly map' beschikbaar",
        mapSettingsExplanation: 'Centrum van de kaart bij het van selecteren van de positie van een object.',
        authenticationTokenExplanation:
            'Token voor koppeling met externe systemen zoals een onboard drone computer. Kan leeg gelaten worden als niet bekend is wat moet worden ingevuld.',
        shouldClusterMarkers: 'Bijellkaar liggende objecten worden samengevoegde wanneer uitgezoomd',
        restrictedHostName: 'Beperkte host name',
        restrictedHostNameExplanation: 'Beperk de gebruiker tot de hostnaam. Geef hostnaam op zonder https.',
        shouldEnforceMfa: 'Verplicht MFA',
        shouldEnforceMfaExplanation: 'Verplicht MFA voor alle gebruikers van dit bedrijf.',
        useEquipmentManagement: 'Maak gebruik van materiaalbeheer',
        useProductTitle: 'Gebruik naam "product" als titel inspectie',
        useProductTitleExplanation: 'De titel "Inspectie" is veranderd naar "Product" in de gebruikers interface',
        daysVisibilityFutureSurveys: 'Zichtbaarheid toekomstige inspecties in dagen',
        daysVisibilityFutureSurveysExplanation: 'Het aantal dagen dat een toekomstige inspectie zichtbaar wordt in het dashboard',
        useAiChat: 'Gebruik AI chat',
        useAiDocumentUpload: 'Gebruik AI document upload',
        useAiDefectDetection: 'Gebruik AI defectdetectie',
        aiDailyTokenLimit: 'Dagelijks AI token limiet',
        aiMonthlyTokenLimit: 'Maandelijks AI token limiet',
    },
    licence: {
        licence: 'Licentie',
        licences: 'Licenties',
        activatedOnDate: 'Geactiveerd op',
        expiresOnDate: 'Verloopt op',
        deviceName: 'Device naam',
        activatedBy: 'Geactiveerd door',
        isStandalone: 'Standalone',
    },
    project: {
        project: 'Project',
        projects: 'Projecten',
        import: 'Import',
        noMeasurements: 'Geen metingen',
        measurement: 'Meting',
        value: 'Waarde',
        scanLines: 'Scanlijnen',
        scanLine: 'Scanlijn',
        position: 'Positie',
        flight: 'Vlucht',
        addScanLineCoordinates: 'Coördinaten toevoegen',
        scanLineStartPoint: 'Begin punt',
        scanLineEndPoint: 'Eind punt',
        positions: 'Posities',
        clickOnValueToEdit: 'Klik op waarde om te bewerken',
        remove: 'Weet u zeker dat u deze metingen permament wilt verwijderen?',
        iconTitleProjectsAvailable: 'UT projecten beschikbaar',
        removeLink: 'Verwijder koppeling metingen',
        scanLineXAxis: 'Scanlijn op de x-as',
        scanLineLabel: 'Alternatief label voor scanlijn',
        positionLabel: 'Alternatief label voor positie',
        isValidated: 'Meetresultaten gevalideerd',
        isValidatedMessage: 'Meetresultaten zijn nog niet gevalideerd.',
        conductedBy: 'Uitgevoerd door',
        importCsv: 'CSV importeren',
        importCsvTitle: 'UT-metingen importeren (CSV)',
        importCsvFile: 'CSV-bestand',
        importCsvNoFile: 'Kies eerst een CSV-bestand',
        importCsvFailed: 'Het importeren van het CSV-bestand is mislukt',
        importCsvChooseFile: 'Bladeren',
        importCsvNoFileSelected: 'Geen bestand gekozen',
        importCsvSkippedWarning: 'Niet alle rijen uit het CSV-bestand konden worden geïmporteerd.',
        importCsvImportedCount: 'Geïmporteerde metingen',
        importCsvSkippedCount: 'Overgeslagen rijen',
    },
    object: {
        filter: 'Objecten filteren',
        lastSurveyDate: 'Laatste inspectie',
        filterByClient: 'Filter op eigenaar',
        filterByStatus: 'Filter op status',
        filterByType: 'Filter op type',
        objectName: 'Object naam',
        objectCode: 'Object code',
        locationDescription: 'Locatie beschrijving',
        latitude: 'Latitude (nn.nnnnn)',
        longitude: 'Longitude (nn.nnnnn)',
        owner: 'Object eigenaar',
        companyRelations: 'Bedrijfsrelatie',
        adminSettings: 'Instellingen voor beheerders',
        isPublic: 'Beschikbaar voor partners',
        useModelComposition: 'Maak gebruik van object decompositie',
        saveObjectAndAddComposition: 'Object opslaan & decompositie bewerken',
        customElement: 'Niet standaard element',
        customUnit: 'Niet standaard onderdeel',
        itemCannotBeRemoved: 'Item kan niet worden verwijderd omdat het wordt gebruikt.',
        list: 'Lijst objecten',
        filterObjectsByObjectLabel: 'Object label',
        surveyList: 'Lijst inspecties',
        objectBreakdown: 'Decompositie',
        areaMap: 'Kaart',
        openInspectionChecklist: 'Open inspectie checklijst',
        notAvailable: 'Object details zijn niet beschikbaar',
        addObject: 'Object toevoegen',
        noItemsOnMap: 'Er zijn geen objecten om te tonen',
        errorNoOwner: 'Geen eigenaar geselecteerd',
        errorNoClient: 'Geen klant geselecteerd',
        errorNoInspectionStandard: 'Geen inspectiestandaard geselecteerd',
        errorCodeNotUnique: 'De objectcode is niet uniek voor de objecteigenaar',
        demoExpDate: 'Demo verval datum',
        elementIsDefault: 'Element wordt standaard toegevoegd bij aanmaken object',
        unitIsDefault: 'Onderdeel wordt standard toegeveoegd bij aanmaken object',
        usage: 'Gebruik',
        construction: 'Constructie',
        constructionYear: 'Bouwjaar',
        combinedConstructionYear: 'Samengesteld uit verschillende bouwjaren',
        externalReference: 'Externe referentie ',
        replacementIndex: 'Vervangingswaarde factor',
        length: 'Lengte',
        width: 'Breedte',
        squareMeters: 'Oppervlakte',
        trafficType: 'Type verkeer',
        mainMaterial: 'Hoofdmateriaal',
        infrastrutureType: 'Kunstwerktype',
        elementGroup: 'Elementgroep',
        structural: 'Constructief',
        copyObjectTypeElementSettings: 'Kopiëer huidige instellingen naar bestaande elementen',
        notFoundObjects: 'Niet gevonden objecten',
        nonUniqueCodes: 'Niet unieke codes',
        managementOrganization: 'Beheerorganisatie',
        managementOrganizations: 'Beheerorganisaties',
        showObject: 'Toon object',
        copyCompositionToSimilarObjects: 'Kopieer decompositie naar soortgelijke objecten',
        copyCompositionFromObject: 'Kopieer decompositie van object',
        selectCompositionFromObject: 'Selecteer object om te kopieren',
        loadClass: 'Belastingklasse',
        area: 'Gebied',
        complexName: 'Naam complex',
        complexCode: 'Code complex',
        codeObjectComplex: 'Code van object of complex',
        inspectionSpecific: 'Inspectie specifiek',
        zxyExchangeAccess: 'Toegang via ZXY Exchange',
        accessLevel: 'Toegangsniveau',
        noAccess: 'Geen toegang',
        anyoneAccess: 'Iedereen toegang',
        selectedAccess: 'Geselecteerde toegang',
        registeredCompanies: 'Geregistreerde bedrijven',
        typeTooltip: 'Onder menu item "Instellingen" kunnen eigen object types worden gedefinieerd.',
        demoTooltip: 'Als een object een demo-object is verschijnt deze geanonimiseerd onder de demo login.',
        shape: 'Vorm',
        line: 'Lijn',
        polygon: 'Polygoon',
        clear: 'Verwijder',
        position: 'Geografische locatie',
        givePosition: 'Selecteer een punt op de kaart of teken de vorm van het object op de kaart om de geografische locatie aan te duiden.',
        hasPoint: 'Object heeft een punt op de kaart',
        hasShape: 'Object heeft een vorm op de kaart',
        selectPoint: 'Selecteer een punt op de kaart',
        drawShape: 'Teken een vorm op de kaart',
        pdokLayer: 'PDOK kaartlagen',
        supplier: 'Leverancier',
        dimension: 'Dimensie',
        strength: 'Sterkte',
        norm: 'Norm',
        exportShape: 'Shape bestand',
        exportShapes: 'Shape bestanden',
        nenReport: 'Nen rapport',
        mjopReport: 'MJOP rapport',
        generalData: 'Algemene gegevens',
        height: 'Hoogte',
        volume: 'Inhoud',
        palen: 'Palen',
        dragers: 'Dragers',
        damwandplanken: 'Damwandplanken',
        loadClassExplanation: 'Belastingklasse',
        replacementValue: 'Vervangingswaarde',
        showOtherObjects: 'Toon andere objecten',
        showOtherObjectsExplanation: 'Zoom in om ander objecten te tonen',
        nameOrCode: 'Naam / Code',
        productList: 'Lijst producten',
        lastProductDate: 'Laatste product',
        labels: 'Object labels',
    },
    condition: {
        excellent: 'Uitstekend',
        good: 'Goed',
        reasonable: 'Redelijk',
        moderate: 'Matig',
        poor: 'Slecht',
        bad: 'Zeer slecht',
        critical: 'Kritisch',
        further: 'Opvolging',
        unknown: 'Onbekend',
        invalid: ' ',
        orLess: '{0} of minder',
        orMore: '{0} of hoger',
    },
    intensity: {
        level1: 'Vroeg stadium',
        level2: 'Gevorderd stadium',
        level3: 'Eind stadium',
    },
    extend: {
        level1: 'Zeer beperkt (< 2 %)',
        level2: 'Lokaal (2 % tot 10 %)',
        level3: 'Frequent (10% tot 30%)',
        level4: 'Regelmatig (30% tot 70%)',
        level5: 'Algemeen (> 70%)',
    },
    seriousness: {
        level1: 'Gering',
        level2: 'Serieus',
        level3: 'Ernstig',
    },
    survey: {
        surveyedOn: 'Datum inspectie',
        updatedOn: 'Datum gewijzigd',
        findSurvey: 'Inspecties filteren',
        filterByClient: 'Filter op eigenaar',
        description: 'Beschrijving inspectie',
        filterOnLabel: 'Filter lijst op labels',
        filterObjectsBySurveyLabel: 'Inspectie label',
        filterOnDescription: 'Filter lijst op beschrijving of tekst in documenten',
        labelsExpl: 'Labels kunnen worden gebruikt voor aanvullende kenmerken om op te filteren.',
        defaultPointCloud: 'Standaard pointcloud',
        customPointCloud: 'Aangepaste pointcloud',
        filenamePointCloud: 'Pointcloud bestandsnaam voor conversie',
        saveSurveyAndAddVisuals: 'Opslaan & data toevoegen',
        manageVisuals: 'Afbeeldingen beheren',
        returnEditInspection: 'Terug naar bewerken rapport',
        conditionAssessment: 'Conditierapport',
        editConditionAssessment: 'Rapport bewerken',
        dataAndDocuments: 'Data en documenten',
        summaryAndAdvice: 'Samenvatting en advies',
        composition: 'Compositie',
        expandAll: 'Alles uitklappen',
        collapseAll: 'Alles inklappen',
        expandAllComposition: 'Decompositie uitklappen',
        collapseAllComposition: 'Decompositie inklappen',
        visualsAvailable: 'Visuals beschikbaar',
        selectInObjectTreeVisual: 'Selecteer een element in de object compositie boom om fotos en videos te beheren.',
        selectInObjectTreeAssessment: 'Selecteer een eindpunt in de object compositie boom om bevindingen te beheren.',
        selectInObjectTreeDataPoint:
            'Er zijn geen metingen om te tonen. Selecteer een eindpunt in de object compositie boom waar metingen onder gepubliceerd staan.',
        dragAndDropUploader: 'Drag and Drop uploader',
        serverNotConfigured: 'Server niet geconfigureerd',
        dropFiles: 'Drop bestand',
        toUpload: 'naar upload',
        orClick: 'of klik hier',
        dropzoneAcceptedFiles: 'Mogelijke bestandstypes: {0}',
        imageUsedInReport: 'Geplaatst in rapport',
        imageOnStartPage: 'Zichtbaar op startpagina',
        commentsAvailable: 'Opmerking beschikbaar',
        removeAllFiles: 'Verwijder alle bestanden',
        composeYourMessage: 'Geef hier uw opmerkingen over geselecteerde onderdeel.',
        conditionAdvice: 'Advies',
        conditionAndAdvice: 'Conditie en advies',
        conditionCost: 'Kosten',
        conditionCostYear: 'Jaar',
        conditionScore: 'Conditie',
        composeSummaryAndAdvice: 'Geef hier uw samenvatting en advies voor het gehele object.',
        '3dModel': '3D model',
        documents: 'Documenten',
        downloads: 'Downloads',
        surveyTab: 'Inspectie ',
        pointcloudTab: 'Pointcloud',
        pointClouds: 'Pointclouds',
        manageVisualsTab: 'Afbeeldingen',
        conditionAssessmentTab: 'Beoordelingen',
        summaryAndAdviceTab: 'Samenvatting',
        generateReportTab: 'Rapportage genereren in Word-formaat',
        mapAndAlternativeMap: 'Kaart en alternatieve kaart',
        open3dViewer: 'Vergroot 3D model in apart scherm',
        open2dViewer: 'Toon in apart scherm',
        edit3dViewer: 'Bewerk 3D model',
        conditionReport: 'Conditierapport',
        downloadPDFReport: 'PDF rapport',
        downloadExcelReport: 'Excel rapport',
        costEstimationPrefix: 'Kosten inschatting: € ',
        costEstimationYearPrefix: 'In jaar ',
        assetAddToReport: 'Voeg toe aan online rapport',
        assetRemoveFromReport: 'Verwijder uit online rapport',
        assetAddToMSWReport: 'Voeg toe aan rapport document',
        assetRemoveFromMSWReport: 'Verwijder uit rapport document',
        assetAddToStartPage: 'Publiceer op startpagina',
        assetRemoveFromStartPage: 'Verwijder van startpagina',
        processing: 'Verwerken...',
        overallCondition: 'Algehele conditie',
        noImages: 'Er zijn geen fotos of videos beschikbaar voor het geselecteerde onderdeel.',
        storageMb: 'Schrijfruimte',
        size: 'Grootte',
        noItemsOnMap: 'Er zijn geen inspecties om te tonen',
        notAvailable: 'Inspectie niet beschikbaar',
        isDOMLight: 'Eye-Dome belichting',
        isAnnotationsDefaultVisible: 'Labels standaard zichtbaar in model',
        cancelUpload: 'Systeem is nog bezig met uploaden. Wilt u het uploaden onderbreken?',
        pointCloudStorageUsed: 'Grootte pointcloud (Mb)',
        conditionDefects: 'Conditie en gebreken',
        conditionRepairs: 'Conditie en reparatie adviezen',
        videosTab: "Video's",
        start: 'Start',
        end: 'Eind',
        showReport: 'Toon rapport',
        editReport: 'Rapport bewerken',
        noPointcloud: 'Geen pointcloud beschikbaar',
        editSurveyData: 'Inspectie data bewerken',
        assetDescriptionIsVisible: "Beschrijving bij foto's en video's beschikbaar",
        isVideoDownloadVisible: 'Originele video bestanden zijn als download beschikbaar',
        internalRemark: 'Interne opmerkingen, niet zichtbaar in rapport',
        allElementsVisible: 'Toon alle elementen',
        defectElementsVisible: 'Toon enkel beoordeelde elementen',
        generateReport: 'Genereer rapport',
        closeAnnotationWindow: 'Annotatiescherm sluiten',
        compositeCondition: 'Samengestelde conditie score',
        compositeCare: 'Samengestelde verzorgingsscore',
        recalculateDerivedCondition: 'Herbereken conditie scores',
        resetConditions: 'Condities resetten en herberekenen',
        resetDefaultMaintenance: 'Genereer standaard maatregelen',
        mailShareLink: 'Verstuur link',
        mailTo: 'Email naar',
        availability: 'Beschikbaar',
        availability2: 'Twee dagen',
        availability14: 'Twee weken',
        availability28: 'Vier weken',
        availability60: 'Twee maanden',
        availability183: 'Half jaar',
        availability0: 'Onbeperkt',
        message: 'Bericht',
        plyModel: 'PLY Model',
        ifcModel: 'IFC Model',
        createMiok: 'Genereeer MJOP rapport',
        investigationPriority: 'Opvolging geprioriteerd',
        reference3dmodel: 'Link naar bestaande pointcloud',
        isFmecaAvailable: 'FMECA',
        isCraAvailable: 'Constructie risicobeoordeling',
        inspectionPlan: 'Inspectie aandachtspunt',
        craInitialHistory: 'Initiële constructieve risicobeoordeling',
        craInspection: 'Definitieve constructieve risicobeoordeling',
        craIsBuildBetween4074: 'Gebouwd tussen 1940-1974',
        craIsStaticallyIndeterminate: 'Statisch onbepaald',
        craInitialHistoryCondition: 'Samengestelde initiële constructieve risicobeoordeling',
        craInspectionCondition: 'Samengestelde definitieve constructieve risicobeoordeling',
        combinedRiskScores: 'Samengestelde scores',
        surveryedOn: 'Inspectie uitgevoerd op',
        inspectionPlans: 'Inspectie aandachtspunten',
        author: 'Auteur',
        preparedBy: 'Opgesteld door',
        verifiedBy: 'Geverifieerd door',
        fmecaRisk: 'FMECA risico',
        riskDefect: 'Risico gebrek',
        riskConstruction: 'Risico constructie',
        riskFailure: 'Risico falen',
        signature: 'Ondertekening',
        closeSurvey: 'Inspectie afsluiten',
        completeSurvey: 'Inspectie afsluiten',
        furtherInvestigation: 'Opvolging verlangd',
        priorityFurtherInvestigation: 'Prioritiet opvolging',
        closeSurveyExplanation:
            'Door het sluiten van deze inspectie kan de inspectie niet langer bewerkt worden. De inspectie kan achteraf alleen nog open worden gezet door een beheerder. Weet u zeker dat u deze inspectie nu wilt sluiten?',
        generate: 'Rapport genereren',
        uploadConvert: 'Upload en converteer pointcloud',
        externalLink: 'Externe link',
        copyImageTo: 'Kopieer beeldmateriaal naar',
        moveImageTo: 'Verplaats beeldmateriaal naar',
        residualLife: 'Restlevensduur',
        residualLifeDisclaimer:
            'Let op: De restlevensduur is enkel een indicatie. De daadwerkelijke restlevensduur is afhankelijk van verschillende factoren die hier niet meegewogen zijn.',
        compare: 'Vergelijk',
        selectSurveyToCompare: 'Selecteer inspectie om te vergelijken',
        importDefaultMaintenance: 'Importeer standaard maatregelen',
        basicData: 'Basis gegevens',
        additionalData: 'Extra gegevens',
        copy: 'Kopieer inspectie',
        copyExplanation:
            "Bij het kopieren van de inspectie worden de foto's, video's en bevindingen die in de decompositie staan gekopieerd. Als de elementen en onderdelen van het doel-object niet aanwezig zijn dan worden deze onderdelen ook niet gekopieerd. Voordat de inspectie gekopieerd wordt dient de decompositie goed te staan.",
        imagesDisplayed: '{0} afbeeldingen van een totaal van {1} worden getoond.',
        imagesLoad: 'Laad meer...',
        referenceNumber: 'Referentienummer',
        projectOrReferenceNumber: 'Rapport- of referentienummer',
        display: 'Weergave',
        visible: 'Zichtbaar',
        temperature: 'Temperatuur',
        open: 'Open inspectie',
        revisionNumber: 'Revisienummer',
        maxFileSizeExplanation: 'Voor {0}-bestanden geldt een maximum van {1} MB.',
        reportDeadlineOnDate: 'Vervaldatum rapport',
        longRunningSurveys: 'Lang lopende inspecties',
        statusUpdatedOn: 'Status aangepast',
        assignmentUpdatedOn: 'Toegewezen op',
        allImagesSelected: 'Alle afbeeldingen zijn zichtbaar in het rapport.',
        allImagesDeselected: 'Alle afbeeldingen zijn niet meer zichtbaar in het rapport',
        allImagesSelectFailed: 'Het mislukte om alle afbeeldingen bij te werken, probeer het later nog eens',
        descriptionOrNumber: 'Beschrijving / nummer',
        selectAllImages: 'Toon alle afbeelding in het rapport',
        deselectAllImages: 'Verberg alle afbeelding in het rapport',
        labels: 'Inspectie labels',
        bulkUpdateExplanation: 'Wijzigingen toepassen op meerdere inspecties tegelijk. Oude waardes zullen vervangen worden.',
        bulkUpdateSurveys: 'Bulk wijzigen van {0} inspecties',
        surveyImportSheetOverride: '{0}: gebruik vaste waarde, negeer waardes uit sheet',
        bulkUpdateAcceptLargeUpdate: 'Weet u zeker dat u voor alle {0} inspecties deze aanpassing wilt doorvoeren.',
        labelUpdateActionAdd: 'Aan bestaande labels toevoegen',
        labelUpdateActionReplace: 'Bestaande labels vervangen',
        scopeTab: 'Scope',
        scopeEditButton: 'Scope bewerken',
        scopePlaceholder: 'Selecteer eerst een object om de scope te bepalen.',
        scopeNoElements: 'Dit object heeft geen elementen om een scope mee te bepalen.',
        scopeSaveFailed: 'Scope kon niet worden opgeslagen. Probeer het opnieuw.',
        explanationTab: 'Toelichting',
        explanationPlaceholder: 'Geef hier een toelichting op de scope.',
    },
    product: {
        filterProduct: 'Producten filteren',
        filterOnLabel: 'Filter lijst op labels',
        longRunningProducts: 'Lang lopende producten',
        type: 'type',
        filterOnDescription: 'Filter lijst op beschrijving of tekst in documenten',
        description: 'Beschrijving product',
        productType: 'Product type',
    },
    repairAdvice: {
        repairAdvice: 'Advies tot reparatie',
        description: 'Beschrijving gewenste reparatie',
        category: 'Onderdeel',
        advice: 'Advies',
        eemua: 'Clasificatie',
        repairDate: 'Reparatie datum',
        add: 'Reparatie advies toevoegen',
    },
    repairCategory: {
        repairImmediately: 'Reparatie direct nodig',
        repairInSixMonths: 'Reparatie binnen 6 maanden',
        repairOnOccasion: 'Reparatie bij gelegenheid',
        repairNextRenovation: 'Reparatie tijdens volgende grote renovatie',
        repairNextInspection: 'Reparatie voor volgende inspectie',
        noRepair: 'Reparatie niet nodig',
    },
    dashboard: {
        surveyList: 'Meest recente inspecties',
        futureSurveyList: 'Toekomstige inspecties in de komende {0} dagen',
        flightLogs: 'Meest recente vluchtlogboeken',
        account: 'Mijn account',
        storageUsed: 'Opslag gebruikt',
        companyUsagesList: 'Maandoverzicht Gebruikte schrijfruimte en objecten',
        noData: 'Er zijn op dit moment (nog) geen gegevens om te tonen. Overzicht wordt maandelijks bijgewerkt.',
        noSurvey: 'Er zijn op dit moment geen inspecties om te tonen',
        faWarningTitle: '2FA is niet ingesteld',
        faWarning1: '2FA (Authenticatie in twee stappen) is niet ingesteld voor uw account.',
        faWarning2: 'Om veilighiedsredenen is het noodzakelijk om dit in te stellen. Dit kan eenvoudig gedaan worden op de profielpagina. ',
        goToProfile: 'Ga naar profiel om 2FA in te stellen',
        assignedSurveyList: 'Toegewezen inspecties',
        assignedProductList: 'Toegewezen producten',
        futureProductList: 'Toekomstige producten in de komende {0} dagen',
        recentProductList: 'Meest recente producten',
    },
    support: {
        support: 'Ondersteuning',
        supportHeader: 'Ondersteuning nodig? Wij helpen u graag verder!',
        myData: 'Contactgegevens',
        yes: 'Ja',
        no: 'Nee',
        callMeBack: 'Terugbel verzoek',
        question: 'Uw vraag of opmerking',
        submit: 'Versturen',
        submitted: 'Uw ondersteuningsverzoek is verstuurd en u krijgt zo snel mogelijk antwoord.',
    },
    video: {
        video: 'Video',
        videos: 'Videos',
        create: 'Maak een fragment',
        playFragment: 'Fragment afspelen',
        saveFragment: 'Fragment bewaren',
        saveStill: 'Still bewaren',
        saved: 'Opgeslagen fragmenten & stills',
        titleInput: 'Titel',
        downscaling: 'Downscaling van video is bezig. Even geduld a.u.b. (Status laag, hoog: ',
        jobError: 'Er is een fout opgetreden bij het downscalen van de video. Probeer het nogmaals.',
        jobCancelled: 'Het downscalen van de video is geannuleerd.',
        generating: 'Bezig met verwerken. Even geduld...',
        copySelection: 'Kopieer vorige selectie',
        options: 'Opties',
        forcePanorama: "Geüploade video's zijn 360 graden video's",
    },
    errorPages: {
        generalTitle: 'Het spijt ons maar er gaat iets mis',
        authorizationTitle: 'Het spijt ons maar er zijn onvoldoende rechten',
        generalBody: 'Er is een fout opgetreden. We gaan het probleem verhelpen.',
        authorizationBody: 'Er is een fout opgetreden doordat er onvoldoende  rechten zijn.',
        generalBody2: 'U kunt het nog een keer proberen of ga naar de ',
        authorizationBody2: 'Probeer het nogmaals door de pagina te herladen of ga naar de ',
        goToDashboard: 'startpagina',
        needHelp: 'Vragen of ondersteuning nodig?',
        generalSendEmail: 'Neem contact met ons op, wij helpen u graag verder.',
        errorRegistration: 'De melding is opgeslagen onder nummer: ',
    },
    failureMode: {
        failureMode: 'Faalwijze',
        failureModes: 'Faalwijzen',
        allFailureModes: 'Alle faalwijzen',
        analysis: 'Bureaustudie',
        verification: 'Inspectie',
        verificationResult: 'Inspectie resultaten',
        maintenance: 'Onderhoud',
        analysisRiskScoreTableHeader: 'I-ORA',
        verificationRiskScoreTableHeader: 'V-ORA',
        maintenanceRiskScoreTableHeader: 'D-ORA',
        functionAndFailureMode: 'Functie & faalwijze',
        failureCauseAndOrigin: 'Faaloorzaak & bron',
        failureCause: 'Faaloorzaak',
        failureOrigin: 'Bron van falen',
        effectOfFailure: 'Gevolg van falen',
        analysisQuestions: 'Inspectie vragen',
        clarification: 'Toelichting',
        analysisVerificationQuestion: 'Inspectie vragen',
        riskScoreHeader: 'Risicoscore',
        analysisDataHeader: 'Functioneel falen bron en gedrag',
        verificationRiskScoreHeader: 'Verificatie risico na inspectie',
        maintenanceRiskScoreHeader: 'Rest-risico na onderhoud',
        findings: 'Bevindingen',
        finding: 'Bevinding',
        risk: 'Risico',
        riskScore: 'Risicoscore',
        riskScoreVerification: 'Risicoscore na inspectie',
        riskScoreMaintenance: 'Risicoscore na onderhoudsmaatregelen',
        copyFromUnit: 'Faalwijze bouwdeel kopieren naar verschijning',
    },
    maintenanceMeasure: {
        maintenanceMeasures: 'Maatregelen',
        maintenanceMeasure: 'Maatregel',
        openMaintenanceMeasures: 'Openstaande maatregelen',
        default: 'Standaard maatregelen',
        worktype: 'Werksoort',
        maintenanceType: 'Klasse',
        urgency: 'Urgentie',
        year: 'Planjaar',
        finalPlanYear: 'Uiterst jaar',
        cycle: 'Cyclus',
        unitPrice: 'Eenheidsprijs',
        costSurcharge: 'Kostenopslag',
        correctiveMaintenance: 'Correctief onderhoud',
        preventiveMaintenance: 'Preventief onderhoud',
        reasonToUpdate: 'Reden van aanpassing',
        scheduledYear: 'Geprogrammeerd jaar',
        implementationYear: 'Uitgevoerd jaar',
        scheduledYearRemarks: 'Geprogrammeerd jaar opmerkingen',
        planYearRemarks: 'Planjaar opmerkingen',
        close: 'Maatregel afsluiten',
        closeQuestion: 'Weet u zeker dat u deze maatregel wilt afsluiten?',
        planned: 'Gepland',
        completed: 'Uitgevoerd',
        showScore: 'Toon score',
        moreThan200Items: 'Er zijn {0} maatregelen gevonden. Hiervan worden er 200 getoond',
    },
    batch: {
        batch: 'Batch',
        batches: 'Batches',
        objectCount: 'Aantal objecten',
        addMultipleObjects: 'Verzameling objecten toevoegen',
        explanationAddMultipleObjects:
            'Meerdere objecten tegelijk toevoegen. Elk object om toe te voegen moet op een aparte regel staan met de code van dat object.',
        executor: 'Uitvoerder',
        showObjectsNotInSelection: 'Toon objecten niet in selectie',
        canSelectCompletedBatches: 'Toon ook afgeronde batches',
        removeAllObjects: 'Alle objecten verwijderen',
        multipleExecutorsWarning: 'Bedrijf "{0}" komt ook voor in batch "{1}".',
        noActiveBatchesForObject: 'Er zijn geen actieve batches voor dit object beschikbaar.',
        timelineTooltip: 'Gepland: {0} - {1}\nWerkelijk: {2} - {3}',
        plannedDate: 'Geplande periode',
        implementationDate: 'Uitvoeringsperiode',
        notSelected: 'Geen batch geselecteerd',
        showRelatedBatches: 'Toon gerelateerde batches',
        hideRelatedBatches: 'Verberg gerelateerde batches',
        noRelatedBatches: 'Geen andere batches voor object',
    },
    batchSearchPeriodTypes: {
        activeInPeriod: 'Actief in periode',
        endsInPeriod: 'Eindigt in periode',
        startsInPeriod: 'Start in periode',
    },
    report: {
        conditionReport: 'Conditierapport',
        inspectionReport: 'Inspectierapport',
        dateInspection: 'Onderzoeksdatum',
        dateReport: 'Datum rapportage',
        inspector: 'Inspecteur',
        images: 'Beeldmateriaal',
        imagesExplanation: 'Ondersteunend beeldmateriaal bij de conditierapportage',
        noImages: "Geen foto's beschikbaar of geen foto's geselecteerd voor",
        notAvailable: 'Het genereren van rapporten in docx formaat is op dit moment alleen beschikbaar voor EEMUA inspecties.',
    },
    inspectionStandard: {
        inspectionTypes: 'Inspectie typen',
        nen2767: 'Toestand (NEN2767)',
        eemua159: 'EEMUA 159 ',
        api653: 'API 653',
        api570: 'API 570',
        fmeca: 'Instandhouding (FMECA)',
        free: 'Vrij',
        memo: 'Notitie',
        model3d: '3D model',
        verificatieBerekening: 'Verificatie berekening',
        undefined: 'onbekend',
    },
    status: {
        open: 'Open',
        active: 'Actief',
        completed: 'Afgerond',
        deleted: 'Verwijderd',
        proposal: 'Voorstel',
    },
    objectStatus: {
        underConstruction: 'In aanbouw',
        inUse: 'In gebruik',
        inMaintenance: 'In onderhoud',
        outOfService: 'Buiten gebruik',
        cancelled: 'Vervallen',
        deleted: 'Verwijderd',
    },
    surveyStatus: {
        open: 'Open',
        conducting: 'Uitvoering',
        completed: 'Afgerond',
        disabled: 'Niet actief',
        deleted: 'Verwijderd',
        delivery: 'Oplevering',
        preparation: 'Voorbereiding',
        reporting: 'Rapportage',
        undefined: 'Onbekend',
    },
    batchStatus: {
        open: 'Open',
        active: 'Actief',
        completed: 'Afgerond',
        deleted: 'Verwijderd',
        proposal: 'Voorstel',
    },
    rams: {
        reliability: 'Betrouwbaarheid',
        availability: 'Beschikbaarheid',
        safety: 'Veiligheid',
        consequentialCosts: 'Gevolgkosten',
        environment: 'Milieu',
    },
    ramsDescription: {
        reliability: 'Manifestatie van risico',
        availability: 'Fractie van tijd dat object niet functioneert',
        safety: 'ARBO- en verkeersveiligheid',
        consequentialCosts: 'De totale corectieve kosten',
        environment: 'Negatief effect op leefomgeving',
    },
    ramsPriority: {
        null: ' ',
        '0': ' ',
        '1': '>5 jaar herstellen',
        '2': '3-5 jaar herstellen',
        '3': '1-2 jaar herstellen',
        '4': 'direct herstellen',
    },
    damage: {
        cause: 'Schade oorzaak',
        location: 'Beschrijving locatie',
        details: 'Details',
        advice: 'Herstel avies',
        collision: 'Aanrijding',
        carbonation: 'Carbonatatie',
        corrosion: 'Corrosie',
        leakage: 'Lekkage',
        applied: 'Niet (juist) aangebracht',
        executed: 'Niet (juist) uitgevoerd',
        washout: 'Uitspoeling',
        vandalism: 'Vandalisme',
        pollution: 'Verontreiniging',
        aging: 'Veroudering',
        deformation: 'Vervorming',
        blockage: 'Verstopping',
        settlement: 'Zettingen',
        other: 'Anders',
    },
    fmecaRisk: {
        '1': 'Laag risico',
        '2': 'Ondergemiddeld risico',
        '3': 'Bovengemiddeld risico',
        '4': 'Hoog risico',
    },
    investigationPriority: {
        '0': 'Unknown',
        '1': 'Laag',
        '2': 'Middel',
        '3': 'Hoog',
    },
    elementGroupName: {
        superstructure: 'Bovenbouw',
        substructure: 'Onderbouw',
        foundation: 'Fundering',
    },
    cra: {
        cra: 'Constructie risicobeoordeling',
        riskAssessment: 'Risicobeoordeling',
        filterConstructionElements: 'Filter constructieve elementen',
        constructionRiskAssessment: 'Constructie risicobeoordeling',
        initialDesignAndModifications: 'Oorspronkelijk ontwerp en modificaties',
        historicalSurveysAndCurrentCalculations: 'Historische inspecties, bestaande berekeningen',
        riskScore0: 'Onbepaald',
        riskScore1: 'Laag risico',
        riskScore2: 'Ondergemiddeld risico',
        riskScore3: 'Bovengemiddeld risico',
        riskScore4: 'Hoog risico',
        riskScoreNull: ' ',
        currentVerification: 'Actuele inspectie',
        craMaxInitialScore: 'Samengestelde risicoscore oorspronkelijke ontwerp en modificaties',
        craMaxHistoryScore: 'Samengestelde risicoscore historische inspecties, bestaande berekeningen',
        craMaxInspectionScore: 'Samengestelde risicoscore inspectie',
        initial: 'Initieel',
        inspection: 'Inspectie',
        inspectionFindings: 'Bevindingen',
        riskScore: 'Onbepaald',
        riskScoreUndefined: 'Onbepaald',
        history: 'Historie',
    },
    fmecaFurtherInvestigation: {
        furtherInvestigation: 'Nader onderzoek',
        priority1: 'Laag',
        priority2: 'Midden',
        priority3: 'Hoog',
    },
    inspectionLabel: {
        scubaInspection: 'Duikinspectie',
        rovInspection: 'ROV inspectie',
        droneInspection: 'drone inspectie',
        traditionalInspection: ' traditionele inspectie',
        inspectionLoad: 'Inspectie last',
        cost: 'Kosten',
        risk: 'Veiligheid',
        inspectorRisk: 'ARBO risico',
        surroundingsRisc: 'Omgevingsrisico',
        aviationRisc: 'Luchtvaartrisico',
        objectRisc: 'Schaderisico',
        traffic: 'Hinder',
        environment: 'Milieu',
        nuisance: 'Hinderklase',
        cO2emissions: 'Indicatie CO2 emissie',
        efficiency: 'Rendement',
        detectionEfficiency: 'Detectie rendement ',
    },
    PotreeConverter: {
        jobs: 'Lopende taken',
        geoConversion: 'Georeferentie conversie',
        none: 'Geen',
        rds: 'Rijksdriehoeksstelsel',
        wgs84: 'WGS 84 (GPS)',
        utmZone: 'UTM zone',
        maxFileSize:
            'Voor .las-bestanden geldt een maximum van 4 Gb. Voor .laz-bestanden is het maximum 1,5 Gb. Grotere bestanden kunnen worden geconverteerd door contact op te nemen met ZXY-Cloud.',
    },
    worker: {
        jobs: 'Taken',
        runningJobs: 'Lopende taken',
        finishedJobs: 'Afgeronde taken',
        uploadZip: 'Bulk upload afbeeldingen in zip-bestand',
        compressedImages:
            'Afbeeldingen in een zip-bestand kunnen worden geüpload. De directorystructuur in het zip-bestand wordt aangemaakt als decompositie. Deze structuur kan drie niveaus diep zijn (voorbeeld: element/bouwdeel/verschijningsvorm), diepere structuren worden genegeerd.',
        lastJobFailed: 'Laatste taak is mislukt',
        potreeFailedWithExitCodeNull:
            'De taak is mislukt omdat de puntenwolk niet kon worden geconverteerd, waarschijnlijk vanwege een onvolledig of ongeldig bestand. Controleer de puntenwolk. Je kunt het ook opnieuw samplen met een programma als Cloud Compare en het opnieuw proberen te uploaden.',
    },
    equipment: {
        management: 'Materiaalbeheer',
        equipment: 'Apparatuur',
        types: 'Type apparatuur',
        inUse: 'In gebruik',
        inMaintenance: 'In onderhoud',
        deleted: 'Verwijderd',
        outOfService: 'Buiten gebruik',
        underConstruction: 'In opbouw',
        expirationDate: 'Vervaldatum',
        reminderDate: 'Datum notficatie verval',
        expireSoon: 'Apparatuur die binnenkort verloopt',
        expiresIn: 'Verloopt in',
        noExpirations: 'Er is geen apparatuur dat binnenkort verloopt.',
        isPayload: 'Onderdeel van een bovenliggend systeem',
        gridView: 'Rasterweergave',
        listView: 'Lijstweergave',
        usedEquipment: 'Gebruikte apparatuur',
        payload: 'Payload',
        carrier: 'Drager',
        general: 'Algemeen',
        incident: 'Incident',
        modification: 'Modificatie',
        repair: 'Reparatie',
        manufacturer: 'Fabrikant',
        typeIndication: 'Type indicatie',
        serialNumber: 'Serienummer',
        softwareVersion: 'Software versienummer',
        hasLog: 'Heeft een logboek',
        flightLogExport: 'Exporteer log naar Excel',
        customFields: 'Extra velden',
        fieldName: 'Veldnaam',
        fieldOrder: 'Volgorde',
        addField: 'Veld toevoegen',
        noFieldsDefined: 'Geen extra velden gedefinieerd voor dit type apparatuur.',

        // BE stuff
        historyReportFilename: 'Geschiedenis-{0}-{1}',
        sheetName: 'Mijn blad',
        dateHeader: 'Datum',
        typeHeader: 'Type',
        descHeader: 'Beschrijving',
    },
    flightLog: {
        log: 'Logboek',
        attachDeviceFirst: 'Voeg eerst apparatuur toe',
        entry: 'Log regel',
        duration: 'Vliegtijd',
        pilot: 'Piloot',
        mins: '{0} min(s)',
        minutes: 'Minuten',
        equipment: 'Apparatuur',
        droneOperator: 'Drone piloot',
        ndtInspector: 'NDT inspecteur',
        selectPilotPlaceholder: 'Select drone operator',
        pilotIsRequired: '"Pilot" is vereist',
        selectEquipmentLabel: 'Gebruikte uitrusting',
        selectEquipmentPlaceholder: 'Selecteer apparatuur',
        equipmentIsRequired: '"Apparatuur" is vereist',
        flightDateLabel: 'Uitvoeringsdatum',
        flightDateRequired: '"Flight date" is vereist',
        flightDurationRequired: '"Vluchtduur" is vereist',
        assetBasedRemarkStub: "Gemaakt op basis van '{0}' bestand",
        projectBasedRemarkStub: "Gemaakt op basis van '{0}' project",
        generateLogFromVideos: "Logboek genereren van video's",
        generateLogsFromMeasurements: 'Logboek genereren uit UT-gegevens',
        deleteAllInSurvey: 'Alle vluchtlogboeken verwijderen',
        confirmDeleteAll: 'Weet u zeker dat u alle vluchtlogboeken in deze enquête wilt verwijderen?',
        selectAssetLabel: 'Selecteer item om de metadata te gebruiken',
        selectAssetPlaceholder: 'Selecteer bestand om mee te beginnen',
        batchCreateBasedOnVideos: "Batch maken van vluchtlogboeken voor alle video's",
        selectProjectPlaceholder: 'Selecteer een project om de afmetingen te gebruiken',
        selectProjectLabel: 'Selecteer project om mee te beginnen',
    },
    assetType: {
        Document: 'Document',
        MeasurementXLS: 'Excel',
        MeasurementPDF: 'PDF',
        Image: 'Afbeelding',
        Video: 'Video',
        DerivedImage: 'Afbeelding',
        DerivedVideo: 'Video',
        ZipArchive: 'Zip-Archief',
        TarArchive: 'Tar-Archief',
        BIM: '3D-model, BIM, CAD',
        '3DModel': '3D-model',
        AutoCad: 'AutoCAD',
        Text: 'Platte tekst',
        Image360: 'Panoramafoto',
        ImageTif: 'Tiff afbeelding',
        ImageAnnotation: 'Geannoteerd beeld',
        IfcModel: 'IFC, BIM model',
        Import: 'Import bestand',
    },
    trafficType: {
        pedestrian: 'Voetganger',
        cyclist: 'Fietser',
        car: 'Auto',
        train: 'Trein',
        tram: 'Tram',
        subway: 'Metro',
        vessel: 'Vaartuig',
        non: 'Geen',
    },
    objectTypeField: {
        fields: 'Velden',
        additionalData: 'Additionele gegevens',
        objectTypeFields: 'Object type velden',
        objectTypeField: 'Object type veld',
        unit: 'Eenheid',
        dataType: 'Data type',
        listOptions: 'Lijst opties',
        category: 'Categorie',
    },
    objectTypeFieldDataType: {
        string: 'Tekst',
        number: 'Cijfer',
        list: 'Lijst',
        boolean: 'Ja/nee',
    },
    NEN: {
        report: 'Rapport',
    },
    FMECA: {
        report: 'Rapport',
    },
    objectRelation: {
        parent: 'Bovenliggend',
        child: 'Onderliggend',
        objectRelation: 'Object relatie',
        objectRelations: 'Object relaties',
        useObjectRelations: 'Gebruik object relaties',
        useObjectRelationsExplanation: 'Wanneer dit aan staat, kunnen objecten ouder/kind relaties hebben.',
        childOfRelations: 'Onderliggende relatie',
        parentOfRelations: 'Bovenliggende relatie',
    },
    workflow: {
        workflow: 'Workflow',
        assignment: 'Toewijzing',
        checklist: 'Checklist',
        comments: 'Opmerkingen',
        addComment: 'Voeg opmerking toe',
        comment: 'Opmerking',
        assignedTo: 'Toegewezen',
        unassigned: 'Niet toegewezen',
        lastComment: 'Laatste opmerking',
        noComment: 'Geen opmerking beschikbaar',
        task: 'Taak',
        updatedBy: 'Bijgewerkt door',
        editChecklist: 'Bewerk checklist',
        notify: 'Notificeer',
        involvedPersons: 'Betrokken personen',
        employee: 'Medewerker',
        filter: 'Filter taken',
        linkToDocuments: 'Link naar documenten',
        openLinkToDocuments: 'Open link naar documenten',
        linkToDocumentsNotSet: 'Link naar documenten niet ingesteld',
        daysFutureSurveys: 'Dagen nieuwe inspecties',
    },
    surveyTaskProgressStatus: {
        open: 'Open',
        completed: 'Voltooid',
        inProgress: 'In behandeling',
        notApplicable: 'Niet van toepassing',
    },
    surveyWorkflowRoles: {
        accountManager: 'Accountmanager',
        pilot: 'Piloot',
        inspector: 'Inspecteur',
        reporter: 'Rapporteur',
        validator: 'Validator',
    },
    videoStream: {
        videoStream: 'Video stream',
    },
    inspectionForms: {
        title: 'Inspectie formulieren',
        form: 'inspectie formulier',
        filter: 'Filter inspectie formulieren',
        template: 'Template',
    },
    label: {
        labelText: 'Label tekst',
        searchLabels: 'Labels zoeken',
        pleaseFirstSelectAClient: 'Selecteer eerst een klant.',
    },
    ai: {
        configuration: 'Configuratie',
        chatModel: 'Chat model',
        embeddingModel: 'Embedding model',
        region: 'Regio',
        status: 'Status',
        connected: 'Verbonden',
        notConfigured: 'Niet geconfigureerd',
        testChat: 'Test Chat',
        send: 'Verstuur',
        placeholder: 'Typ een bericht om AI te testen...',
        tokensUsed: 'Tokens gebruikt',
        you: 'Jij',
        thinking: 'Aan het denken...',
        newConversation: 'Nieuw gesprek',
        errorOccurred: 'Er is een fout opgetreden',
    },
    chat: {
        openObjectChat: 'Stel een vraag over dit object',
        openSurveyChat: 'Stel een vraag over deze inspectie',
        openGeneralChat: 'Stel een vraag',
        // {0} is filled with the user's first name; greeting shown only on
        // a fresh conversation (panel renders nothing for an empty bubble
        // list otherwise — felt cold).
        greeting: 'Hoe kan ik helpen, {0}?',
        greetingNoName: 'Hoe kan ik helpen?',
        chatAboutObject: 'Chat over {0}',
        chatAboutSurvey: 'Chat over {0}',
        chatGeneral: 'Algemene AI Chat',
        send: 'Verstuur',
        stop: 'Stop',
        startNewChat: 'Nieuwe chat',
        maxMessagesReached: 'Deze chat heeft het maximum van 50 berichten bereikt. Start een nieuwe chat over dit onderwerp.',
        placeholder: 'Stel je vraag…',
        you: 'Jij',
        assistant: 'ZXY Cloud',
        // Spec: rotating "thinking..." line shown until the first chunk arrives.
        // Order matters — index drives rotation; keep the count stable so
        // tests that snapshot it stay green.
        progressMessages: [
            'Hmmm…',
            'Interessant…',
            'Bezig…',
            'Aan het contempleren…',
            'Even zoeken…',
            'Even lezen wat er staat…',
            'Aan het spitten door de data…',
            'Laat me nog een verder kijken…',
            'Sorry, nog even bezig…',
            'Nog even geduld, ik ben er bijna…',
            'Je vraagt me ook wel wat…',
            'Ploeteren…',
            'Zweten…',
            'Het gaat lukken hoor…',
            'Nog even mijn resultaten organiseren…',
        ],
        // Footer disclaimer required by the spec; shown under the input on
        // every chat panel. Do NOT shorten without product approval.
        disclaimer: 'De chat is nog in beta en kan mogelijk niet de juiste of verkeerde informatie teruggeven. Controleer altijd de resultaten.',
        // Refusal-line the system prompt instructs the model to use; also
        // shown to the user when the chat backend recognises a write-intent
        // before even calling the model.
        refusalWriteAction: 'Ik kan helaas geen gegevens voor je aanpassen, toevoegen of verwijderen. Ik heb niet de rechten om dit te doen.',
        sourcesLabel: 'Bronnen',
        interruptedLabel: 'Onderbroken — antwoord is mogelijk incompleet.',
        // SSE error sent when the assembler can't build any usable
        // context (object/survey gone, no docs, etc.).
        noContextAvailable: 'Geen context beschikbaar voor deze chat.',
    },
};
